import React from 'react';
import classNames from 'classnames';

import { ReactComponent as ChevronDownIcon } from '../../../assets/icons/chevron-down.svg';
import { ReactComponent as ChevronUpIcon } from '../../../assets/icons/chevron-up.svg';
import css from './PopupOpenerButton.module.css';

/**
 * PopupOpenerButton component
 *
 * @component
 * @param {Object} props
 * @param {boolean} [props.isSelected] - Whether the filter is selected
 * @param {boolean} [props.isOpen] - Whether the popup is open (controls chevron direction)
 * @param {number} [props.labelMaxWidth] - The maximum width of the label
 * @param {Function} props.toggleOpen - The function to toggle the filter
 * @param {React.Node} props.children - The children
 * @returns {JSX.Element}
 */
const PopupOpenerButton = props => {
  const { isSelected = false, isOpen = false, labelMaxWidth = null, toggleOpen, children } = props;

  const labelStyles = isSelected ? css.labelSelected : css.label;
  const labelMaxWidthMaybe = labelMaxWidth ? { maxWidth: `${labelMaxWidth}px` } : {};
  const labelMaxWidthStyles = labelMaxWidth ? css.labelEllipsis : null;

  return (
    <button
      type="button"
      className={classNames(labelStyles, labelMaxWidthStyles)}
      style={labelMaxWidthMaybe}
      onClick={() => toggleOpen()}
      aria-expanded={isOpen}
    >
      <span className={css.buttonContent}>
        <span className={css.buttonText}>{children}</span>
        {isOpen ? (
          <ChevronUpIcon className={css.chevronIcon} />
        ) : (
          <ChevronDownIcon className={css.chevronIcon} />
        )}
      </span>
    </button>
  );
};

export default PopupOpenerButton;
